import axios, { AxiosRequestConfig } from "axios";
import HP from "../../host";
import { saveAs } from 'file-saver';

//Add New Flight
export async function addNewFlight(body: object) {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/flight`;
  const accessToken = localStorage.getItem('token');
  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,
  };

  const response = await axios.post(apiUrl, body, {
    headers: headers
  });

  return response.data;

}

//Delete Flights
export async function deleteFlight(id: string) {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/flight/${id}`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,

  };

  const response = await axios.delete(apiUrl, {
    headers: headers
  });

  return response.data;
}

//Update Flight
export async function updateFlight(id: string, body: object) {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/flight/${id}`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,

  };

  const response = await axios.patch(apiUrl, body, {
    headers: headers
  });

  return response.data;
}

//View Flight
export async function getFlightbyId(id: string) {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/flight/${id}`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,

  };

  const response = await axios.get(apiUrl, {
    headers: headers
  });

  return response.data;
}

/*Client Aircraft Api's*/
//Delete Aircraft
export async function deleteaircraft(id: string) {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/aircraft/${id}`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,

  };

  const response = await axios.delete(apiUrl, {
    headers: headers
  });

  return response.data;

}

//Update Aircraft
export async function updateAircraft(id: string, body: object) {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/aircraft/${id}`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,

  };

  const response = await axios.patch(apiUrl, body, {
    headers: headers
  });

  return response.data;

}

//AerpoApi
export async function getAircraftAeroApi(id: string) {
  return await axios.get(`${HP.request}://${HP.host}/api/v1/aeroapiaircrafthistory/getaircrafthistory/${id}`);
}

//Add new Aircraft
export async function addNewAircraft(body: object) {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/aircraft`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,

  };

  const response = await axios.post(apiUrl, body, {
    headers: headers
  });

  return response.data;

}

//Get all Aircrafts
export async function getAircraft() {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/aircraft`;
  const accessToken = localStorage.getItem('token');
  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,
  };
  const response = await axios.get(apiUrl, {
    headers: headers
  });
  console.log("bodyy", response);
  return response.data;
}

//AeroApi Flight by Flight Number
export async function getFlightData(id: string) {
  return await axios.get(`${HP.request}://${HP.host}/api/v1/aeroapiflight/getflightdata/${id}`);
}

//Get all Flights
export async function getFlight() {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/flight`;
  const accessToken = localStorage.getItem('token');
  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,
  };

  const response = await axios.get(apiUrl, {
    headers: headers
  });
  return response.data;
}

//AeroApi Flight by Date
export async function getFlightbyDate(body: object) {
  return await axios.post(`${HP.request}://${HP.host}/api/v1/aeroapiflight/getflighthistoryDatawithonedate`, body);
}

//Change Password
export async function changePassword(body: object) {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/users/changepassword`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,

  };

  const response = await axios.post(apiUrl, body, {
    headers: headers
  });

  return response.data;

}

//FlightReport
export async function getReportbyFlight(body: object) {
  const accessToken = localStorage.getItem('token');
  const apiUrl = `${HP.request}://${HP.host}/api/v1/report/pilot-log`;

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,
  };

  try {
    const response = await axios.get(apiUrl, { responseType: 'json', headers, params: body });
    //const blob = new Blob([response.data], { type: 'application/pdf' });
    //saveAs(blob, 'report.pdf');
    return response?.data?.file;
  } catch (error) {
    console.error('Error fetching or downloading the PDF:', error);
    throw error;
  }
}

//AircraftReport
export async function getReportbyAircraft() {
  const accessToken = localStorage.getItem('token');
  const apiUrl = `${HP.request}://${HP.host}/api/v1/report/logbook/summary`;

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,
  };

  try {
    const response = await axios.get(apiUrl, { responseType: 'json', headers });
    // const blob = new Blob([response.data], { type: 'application/json' });
    // saveAs(blob, 'report.pdf');
    return response?.data?.file;
  } catch (error) {
    console.error('Error fetching or downloading the PDF:', error);
    throw error;
  }
}

//Get Stats
export async function getStats() {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/stats/dashboard/`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,
  };

  const response = await axios.get(apiUrl, {
    headers: headers
  });

  return response.data;
}

//Graph Stats Client
export async function getChart(id:string) {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/admin/overview/user/flights/${id}`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,
  };

  const response = await axios.get(apiUrl, {
    headers: headers
  });

  return response.data;
}


//Export Flights Report
export async function exportFlight() {
  const accessToken = localStorage.getItem('token');
  const apiUrl = `${HP.request}://${HP.host}/api/v1/flight/export`;

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
  };

  try {
    const response = await axios.get(apiUrl, {
      headers: headers,
      responseType: 'json', // Important to handle binary data
      params: { token: accessToken } // Correct way to pass parameters
    });

    // const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    // saveAs(blob, 'flight_data.xlsx');
    return response?.data?.file;
  } catch (error) {
    console.error('Error downloading file', error);
  }
}

//Import Flight Report
export async function importFlight(file: File) {
  const accessToken = localStorage.getItem('token');
  const apiUrl = `${HP.request}://${HP.host}/api/v1/flight/import`;

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }

  const headers = {
    'Content-Type': 'multipart/form-data', // Use multipart/form-data for file upload
    Authorization: `Bearer ${accessToken}`,
  };

  const formData = new FormData();
  formData.append('file', file); // Assuming you want to send the file in a field named 'file'

  try {
    const response = await axios.post(apiUrl, formData, {
      headers: headers,
    });

    return response.data;
  } catch (error) {
    console.error('Error uploading file', error);
  }
}

//AutoLog Functionality
export async function aircraftAutolog(id: string) {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/aircraft/auto-log/${id}`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,

  };
  const response = await axios.get(apiUrl, {
    headers: headers
  });

  return response.data;
}


//Get all airports
export async function getAirports() {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/airport`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,
  };
  const response = await axios.get(apiUrl, {
    headers: headers
  });
  console.log("bodyy", response);
  return response.data;
}

//Create Airport
export async function addAirport(body: object) {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/airport`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,
  };

  const response = await axios.post(apiUrl, body, {
    headers: headers
  });

  return response.data;

}

export async function deleteAirport(id: string) {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/airport/${id}`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,

  };

  const response = await axios.delete(apiUrl, {
    headers: headers
  });

  return response.data;
}

/*Admin Api's*/

//Get all Users
export async function getUsers(currentPage:any) {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/admin/users?page=${currentPage}`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,
  };
  const response = await axios.get(apiUrl, {
    headers: headers
  });
  console.log("bodyy", response);
  return response.data;

}

//Search Users
export async function getUsersbySearch(username:any) {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/admin/users?search=${username}`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,
  };
  const response = await axios.get(apiUrl, {
    headers: headers
  });
  console.log("bodyy", response);
  return response.data;

}

//Get user by id
export async function getUserbyId(id: string) {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/admin/users/${id}`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,

  };

  const response = await axios.get(apiUrl, {
    headers: headers
  });

  return response.data;
}

//Update User
export async function updateUser(id: string, body: object) {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/admin/users/${id}`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,

  };

  const response = await axios.patch(apiUrl, body, {
    headers: headers
  });

  return response.data;
}

//Invite User
export async function InviteUser(body: object) {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/admin/users/invite/`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,
  };

  const response = await axios.post(apiUrl, body, {
    headers: headers
  });

  return response.data;

}

//Delete User
export async function deleteUser(id: string) {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/admin/users/${id}`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,

  };

  const response = await axios.delete(apiUrl, {
    headers: headers
  });

  return response.data;
}

//Change Active Status
export async function statusChange(id: string) {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/admin/users/status-change/${id}`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,

  };

  const response = await axios.put(apiUrl,{},{
    headers: headers
  });

  return response.data;
}


//MultiDelete User
export async function multiDeleteUsers(ids: string[]) {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/admin/users/`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
  };

  const config: AxiosRequestConfig = {
    headers: headers,
    data: { ids: ids },
  };

  try {
    const response = await axios.delete(apiUrl, config);
    return response.data;
  } catch (error) {
    console.error('Error deleting users:', error);
    throw error;
  }
}


//Groups Lookup
export async function groupsLookup() {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/admin/groups/lookup/`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,
  };
  const response = await axios.get(apiUrl, {
    headers: headers
  });
  console.log("bodyy", response);
  return response.data;

}

//Create Group
export async function createGroup(body: object) {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/admin/groups/`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,
  };

  const response = await axios.post(apiUrl, body, {
    headers: headers
  });

  return response.data;

}

//get Admin Flights
export async function getAdminFlights(currentPage:any) {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/admin/flight?page=${currentPage}`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,
  };
  const response = await axios.get(apiUrl, {
    headers: headers
  });
  console.log("bodyy", response);
  return response.data;

}

//Delete Admin Flights
export async function deleteFlightsAdmin(id: string) {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/admin/flight/${id}`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,

  };

  const response = await axios.delete(apiUrl, {
    headers: headers
  });

  return response.data;
}

//get groups
export async function getGroups() {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/admin/groups/`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,
  };
  const response = await axios.get(apiUrl, {
    headers: headers
  });
  console.log("bodyy", response);
  return response.data;

}

//Delete group
export async function deleteGroup(id: string) {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/admin/groups/${id}`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,

  };

  const response = await axios.delete(apiUrl, {
    headers: headers
  });

  return response.data;
}

//get Group by Id
export async function getGroupbyId(id: string) {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/admin/groups/${id}`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,

  };

  const response = await axios.get(apiUrl, {
    headers: headers
  });

  return response.data;
}

//Update Groups
export async function updateGroup(id: string, body: object) {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/admin/groups/${id}`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,

  };

  const response = await axios.patch(apiUrl, body, {
    headers: headers
  });

  return response.data;
}


//get Admin Stats
export async function getAdminStats() {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/admin/overview/`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,
  };
  const response = await axios.get(apiUrl, {
    headers: headers
  });
  console.log("bodyy", response);
  return response.data;

}

//get Admin Dashboard Graph
export async function getAdminChart() {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/admin/overview/flights/`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,
  };
  const response = await axios.get(apiUrl, {
    headers: headers
  });
  console.log("bodyy", response);
  return response.data;

}

//get Stats for user on Admin side
export async function getUserStats(id: string) {
  const apiUrl = `${HP.request}://${HP.host}/api/v1/admin/overview/user/${id}`;
  const accessToken = localStorage.getItem('token');

  if (!accessToken) {
    console.error('Access token not found in localStorage');
    return;
  }

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,

  };

  const response = await axios.get(apiUrl, {
    headers: headers
  });

  return response.data;
}

